import DefaultModel from '@/common/models/commonClass.model';

const UNKNOWN_GROUP = 'unknown';

export default class AlertModel extends DefaultModel {
  declare group?: string;
  declare details?: { component?: string };

  constructor(attrs) {
    super(attrs);

    if (!this.group || this.group === UNKNOWN_GROUP) {
      this.group = this.details?.component || this.group;
    }
  }
}
